import { render, staticRenderFns } from "./ChatGPTForm.vue?vue&type=template&id=add572b2"
import script from "./ChatGPTForm.vue?vue&type=script&lang=js"
export * from "./ChatGPTForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add572b2')) {
      api.createRecord('add572b2', component.options)
    } else {
      api.reload('add572b2', component.options)
    }
    module.hot.accept("./ChatGPTForm.vue?vue&type=template&id=add572b2", function () {
      api.rerender('add572b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ChatGPTForm.vue"
export default component.exports